import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './plansetup.module.scss';
import { ExpandMore } from '@mui/icons-material';
import { Button, Chip } from '@mui/material';
import FilterData from './FilterData';
import CustomTabPanel from '../../../components/commonComponent/CustomTabPanel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { format } from 'date-fns';

interface PlanProps {
  handleClick: () => void;
  handleFilterChange: () => void;
}


const PlanSetup: React.FC<PlanProps> = ({ handleClick, handleFilterChange }) => {
  const [value, setValue] = useState(0);
  const [expanded, setExpanded] = useState<boolean>(true);
  const { params, sites, dayparts } = useSelector((state: RootState) => state.productionPlan);
  const { regions } = useSelector((state: RootState) => state.region);
  const menuDate = params ? format(new Date(params.menudate), 'dd MMM yyyy') : 'No Date';
  const selectedSites = params ? sites?.filter(site => params?.siteidlist?.includes(site.siteid)) : [];
  const selectedDayParts = params ? dayparts?.filter(daypart => params?.daypartidlist?.includes(daypart.id)) : [];
  const selectedRegionIds = Array.isArray(params?.regionid) ? params.regionid.map(String) : [];
  const selectedRegions = selectedRegionIds.length
    ? (regions || []).filter((region: any) => selectedRegionIds.includes(String(region?.regionid)))
    : [];
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleToggleChange = () => {
    setExpanded(!expanded);
  };
  return (
    <div className="white-box mb-12">
      <div
        className={`flex justify-content-between align-items-center ${expanded ? styles.tabbingDataWrap : styles.tabbingDataWrapMinimize
          }`}
      >
        <div className="flex justify-content-between align-items-center">
          {expanded ? (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Tabs"
              className={!expanded ? "tabs-wrapper colapsed" : "tabs-wrapper"}
            >
              <Tab
                label="Filter"
                id={`simple-tabpanel-${0}`}
                aria-labelledby={`simple-tab-${0}`}
                disableRipple
              />
            </Tabs>
          ) : (
            <>
              <div className={styles.dateRange}>
                <span className={styles.dateLabel}>Dates:</span>
                <span className={styles.date}>{menuDate}</span>
              </div>
              <div
                className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}
              >
                <span className={styles.dateLabel}>Region:</span>
                {params ? (
                  <span className={styles.chipData}>
                    {params?.regionid === null ? (
                      <Chip label="All" className={styles.chip} />
                    ) : selectedRegions.length > 0 ? (
                      selectedRegions.map((region: any, index: number) => (
                        <Chip
                          key={index}
                          label={region?.regionname}
                          className={styles.chip}
                        />
                      ))
                    ) : (
                      <Chip label="All" className={styles.chip} />
                    )}
                  </span>
                ) : (
                  <span className={styles.chipData}>--</span>
                )}
              </div>
              <div
                className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}
              >
                <span className={styles.dateLabel}>Site:</span>
                {params ? (
                  <span className={styles.chipData}>
                    {params?.allsite ? (
                      <Chip label="All Site" className={styles.chip} />
                    ) : (
                      selectedSites?.map((site: any, index) => (
                        <Chip
                          key={index}
                          label={`${site?.sitealias} (${site?.sitecode})`}
                          className={styles.chip}
                        />
                      ))
                    )}
                  </span>
                ) : (
                  <span className={styles.chipData}>--</span>
                )}
              </div>
              <div
                className={`selecte-sites flex align-items-center justify-content-start ${styles.selectedSites}`}
              >
                <span className={styles.dateLabel}>Mealtime:</span>
                {params ? (
                  <span className={styles.chipData}>
                    {params?.allmeal ? (
                      <Chip label="All" className={styles.chip} />
                    ) : selectedDayParts?.map((daypart: any, index) => (
                      <Chip
                        key={index}
                        label={`${daypart?.name}`}
                        className={styles.chip}
                      />
                    ))}
                  </span>
                ) : (
                  <span className={styles.chipData}>--</span>
                )}
              </div>
            
            </>
          )}
        </div>
        <Button
          onClick={handleToggleChange}
          className={`expend-btn ${expanded && "active"}`}
          disableRipple
        >
          {expanded ? "Minimize" : "Expand"}
          <span>
            <ExpandMore />
          </span>
        </Button>
      </div>
      <div className={`inner-contant ${!expanded && "d-none"}`}>
        <CustomTabPanel value={value} index={0}>
          <FilterData
            handleClick={handleClick}
            handleMenuChange={handleToggleChange}
            handleFilterChange={handleFilterChange}
          />
        </CustomTabPanel>
      </div>
    </div>
  );
};
export default PlanSetup;
